import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Button } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

interface RHFFileInputProps {
  name: string;
  label?: string;
  accept?: string;
  multiple?: boolean;
  onFileSelect?: (files: FileList | null) => void;
  [key: string]: any;
}

export const RHFFileInput = React.memo(({ 
  name, 
  label = "Upload File", 
  accept = "*/*", 
  multiple = false,
  onFileSelect,
  ...other 
}: RHFFileInputProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div>
          <input
            type="file"
            id={`file-input-${name}`}
            accept={accept}
            multiple={multiple}
            style={{ display: 'none' }}
            onChange={(e) => {
              const files = e.target.files;
              field.onChange(files);
              if (onFileSelect) {
                onFileSelect(files);
              }
            }}
          />
          
          <Button
            variant="outlined"
            component="label"
            htmlFor={`file-input-${name}`}
            startIcon={<CloudUploadIcon />}
            sx={{ minWidth: 'auto' }}
          >
            {label}
          </Button>
          
          {error && (
            <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
              {error.message}
            </div>
          )}
        </div>
      )}
    />
  );
});
